// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__15n45","col":"styles_col__3rTl1","fulfillmentStatus":"styles_fulfillmentStatus__1KF76","emailCol":"styles_emailCol__1Qhlq"};